import { useHasPermission } from '@contexts/permissions-provider';
import { useFlags } from 'launchdarkly-react-client-sdk';
import React from 'react';

import type {
  OverviewWidgets,
  UseOverviewWidgetsReturn,
} from './useOverviewWidgets.types';

export function useOverviewWidgets(): UseOverviewWidgetsReturn {
  const { precheckinMfeEnabled } = useFlags();
  const isTrainee = useHasPermission('AccessPassWithTraining_View_Own');

  const widgets: OverviewWidgets = React.useMemo(
    () => ({
      precheckin: isTrainee && precheckinMfeEnabled,
      upcomingReservation: true,
      libraryPackage: true,
      upcomingVisit: true,
    }),
    [isTrainee, precheckinMfeEnabled]
  );

  const totalWidgetsToLoad = React.useMemo(() => {
    return Object.values(widgets).filter(Boolean).length;
  }, [widgets]);

  const [loadedWidgets, setLoadedWidgets] = React.useState(0);
  const isPageLoading = loadedWidgets < totalWidgetsToLoad;

  const handleWidgetLoad = React.useCallback((): void => {
    setLoadedWidgets(prev => prev + 1);
  }, []);

  React.useEffect(() => {
    setLoadedWidgets(0);
  }, [totalWidgetsToLoad]);

  return { widgets, isPageLoading, handleWidgetLoad };
}
